<template>
  <div>
    loading...
  </div>
</template>
<script>
// import { cryptoEncrypt,cryptoDecode } from "../until/encrypt.js"
// import { Encrypt,Decrypt } from "../until/ZeusApiSDK/Logic/CryptoLogic"
// import { GetCurrentUserRoles } from "../until/ZeusApiSDK/Logic/HomeLogic";
// import { getUserRole } from "../until/ZeusApiSDK/Logic/Role";

export default {
  data(){
    return {
      // currentUser: {},
      // currentRole: {},
      // Roles : {},
      // userInfo : {}
    }
  },
  
  methods: {
  },
  async created(){
  }
}
</script>
<style lang="less" scoped>

</style>